import { render } from "./SampleInformation.vue?vue&type=template&id=4698fe28&scoped=true"
import script from "./SampleInformation.vue?vue&type=script&lang=js"
export * from "./SampleInformation.vue?vue&type=script&lang=js"

import "./SampleInformation.vue?vue&type=style&index=0&id=4698fe28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4698fe28"]])

export default __exports__